import { HttpClient } from '@angular/common/http';
import { Variable } from '@angular/compiler/src/render3/r3_ast';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_URLS } from '@app/constants/app-urls';
import { DayData } from '@components/calendar/calendar-day/calendar-day.model';
import { CalendarService } from '@components/calendar/calendar.service';
import { CalendarSelectDateService } from '@components/popup-calendar/calendar-select-date.service';
import { NgbCalendar, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { EmployeesService } from '@services/employees/employees.service';
import { FileExporterService, NotificationsService, ObservatoryService, StorageService } from '@services/services.module';
import { Subject, Subscription } from 'rxjs';
import { OfficeData } from '../calendarios-bloqueo/calendario.model';

@Component({
  selector: 'app-gestion-calendarios',
  templateUrl: './gestion-calendarios.component.html',
  styleUrls: ['./gestion-calendarios.component.scss']
})

export class GestionCalendariosComponent implements OnInit, OnDestroy {
  public APP_URLS = APP_URLS;
  dayList: DayData[];
  userData: any;
  dateYear: any;
  dateMonth: any;
  dateMonthStr;
  fechaBloqHasta;
  anio: string;
  mes: string;
  dia: string;
  bandera = true;
  fechaInicialReport: any;
  fechaFinalReport: any;
  resetoFechasFocusCalendar: Subject<void> = new Subject<void>();
  open = false;
  markDisable: boolean;
  transferList: Array<any>;
  transferKeys: string[];
  oficinas = [];
  fileList1 = null;
  errorfile = false;
  tituloIficina = " ";
  officeSelect: OfficeData;
  festiveDays: Array<any> = [];
  entrada = false;
  endfestiveDays: any;

  private subscriptions: Array<Subscription> = [];

  constructor(
    public calendar: NgbCalendar,
    public _calendarService: CalendarService,
    public config: NgbDatepickerConfig,
    public calendarSelectDate: CalendarSelectDateService,
    public fileExporterService: FileExporterService,
    private notification: NotificationsService,
    private employeesService: EmployeesService,
    private titleService: Title,
    private storage: StorageService,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private observatory: ObservatoryService,
    private router: Router,
    private readonly http: HttpClient
  ) {
    window.scrollTo(0, 0);
  }


  ngOnInit() {
      this.userData = this.storage.get('userDataStorage');
      this.employeesService.getEmployeeData(this.userData.employeeNumber).subscribe(admin => {
      this.translate.get(this.activatedRoute.snapshot.data['title']).subscribe((res: string) => {
        this.titleService.setTitle(res);
        this.markDisable = true;
      });

      this.employeesService.getOffices().subscribe((data: any[]) => {
        if (data) {
          this.oficinas = data;
          this.officeSelect = this.oficinas.find(office => office.intOfiId === admin[0].officeId);
          this.officeChange();
        }
      });
    });


  }

  // no se Usa de momento en el calendario-bloqueos, pero es para resetear  el focus
  resetear() {
    this.resetoFechasFocusCalendar.next();
  }

  routeTo(route) {
    this.router.navigate([route]);
  }

  loadLockedDates() {
    this.markDisable = false;
    setTimeout(() => {
      this.markDisable = true;
      this.observatory.setData('loader', false);
    }, 1500);
  }

  fileUpload(event) {
    let fileList: FileList = event.target.files;
    this.fileList1 = fileList[0].name
    if (fileList.length > 0) {
      this.fileExporterService.postCalendarExcel(fileList[0]).subscribe(res => {
        if (res.response === "OK") {
          this.errorfile = false;
          this.notification.setSuccess(this.translate.instant('GESTION_CALS.EXPORT_NOTIFICATION'));
          this._calendarService.getAllFestives(this.officeSelect.intOfiId).subscribe(res => {
              this.festiveDays = res;
          });
        }
      }, (error) => {
        this.errorfile = true;
        this.notification.setError(this.translate.instant('ERRORS.'+ error.error.code));
      });
    }
  }

  officeChange() {
    this._calendarService.getAllFestives(this.officeSelect.intOfiId).subscribe(res => {
      if (res) {
        this.festiveDays = res;
        this.endfestiveDays = this.festiveDays[this.festiveDays.length - 1].dateFestiveOffice
        this.tituloIficina = this.officeSelect.description
        if(this.entrada){
          this.notification.setSuccess(`${this.translate.instant('GESTION_CALS.CHANGE_OFICES')}${this.officeSelect.description}`);
        }
        this.entrada=true;
      }
    });

  }

  ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }
}
